import { render, staticRenderFns } from "./OmnichannelCompleted.vue?vue&type=template&id=6d6489b7&scoped=true"
import script from "./OmnichannelCompleted.vue?vue&type=script&lang=js"
export * from "./OmnichannelCompleted.vue?vue&type=script&lang=js"
import style0 from "./OmnichannelCompleted.vue?vue&type=style&index=0&id=6d6489b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6489b7",
  null
  
)

export default component.exports